import { createStore, createStyleSet } from 'botframework-webchat';
import classNames from 'classnames';
import React, { memo, useCallback, useMemo, useState,useEffect } from 'react';
import { Middleware } from 'redux';
import WebChat from './WebChat';
import axios from 'axios';
import { appConfig } from '../../../utils/app.config';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import warwickbotlogo from '../../../assets/warwickBotlogo_final.png';

// import './fabric-icons-inline.css';
import './MinimizableWebChat.css';

function MinimizableWebChat({ bot = "B0001" }) {
  const [loaded, setLoaded] = useState(false);
  const [minimized, setMinimized] = useState(true);
  const [newMessage, setNewMessage] = useState(false);
  const [side, setSide] = useState('right');
  const [token, setToken] = useState<string>('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [sendMessage, setSendMessage] = useState(false); // Track voice state
  const [message, setMessage] = useState('');
  const [isListening, setIsListening] = useState(false); // Track if listening to speech

  const [isVisible, setIsVisible] = useState(true);
  const [notify, setNotify] = useState("Hi, I'm Itika, how can I help?");

  // Middleware for Redux store
  const middleware: Middleware = ({ dispatch }) => (next) => (action: any) => {

    return next(action);
  };

  const store = useMemo(() => createStore({}, middleware), []);

  const styleSet = useMemo(() => createStyleSet({
    backgroundColor: 'Transparent'
  }), []);


  const styleOptions = useMemo(() => (
    {

      backgroundColor: 'Transparent',
      botAvatarImage: 'https://itika-va.warwick.ac.uk/ui/warwickBotlogo_final.png',
      botAvatarBackgroundColor: 'rgba(0, 0,255, .1)',
      botAvatarInitials: 'B',
      bubbleNubSize: 10,
      bubbleBorderRadius: 10,
      bubbleNubOffset: 6,
      bubbleBackground: 'rgba(0, 0, 255, .1)',
      bubbleFromUserBackground: 'rgba(0, 0, 255, 0.28)',
      userAvatarImage: 'https://itika-va.warwick.ac.uk/ui/User_Profile_Opt1_final.png',
      userAvatarInitials: 'U',
      userAvatarBackgroundColor: '#F77',
      bubbleFromUserBorderRadius: 10,
      bubbleFromUserNubOffset: 6,
      bubbleFromUserNubSize: 6,
      avatarSize: 40,
      emojiSet: {
        ':sheep:': '🐑',
        '<3': '❤️'
      },
      hideUploadButton: true, // Enable upload button
      uploadButtonColor: '#0078D4',
      sendBoxBackground: 'white',
      sendBoxTextColor: 'black'
    }
  ), []);

 
  
const handleFetchToken = useCallback(async () => {
  try {
    if (token) return;

    const res = await fetch(
      '/api/uno64/chatbot_token_apibot/get-directline-token',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!res.ok) {
      throw new Error(`Token fetch failed: ${res.status}`);
    }

    const data = await res.json();
    // console.log('--token:', data.result.token);

    setToken( data.result.token);

  } catch (error) {
    console.error('Error fetching DirectLine token:', error);
  }
}, [setToken, token]);

  const handleMaximizeButtonClick = useCallback(() => {
    setLoaded(true);
    setMinimized(false);
    setNewMessage(false);
  }, []);

  const handleMinimizeButtonClick = useCallback(() => {
    setMinimized(true);
    setNewMessage(false);
  }, []);

  const handleExpandButtonClick = useCallback(() => {
    setIsExpanded(!isExpanded); // Toggle expansion
  }, [isExpanded]);

  const handleSwitchButtonClick = useCallback(() => {
    setSide(side === 'left' ? 'right' : 'left');
  }, [side]);

  // Voice recognition
  const handleVoiceButtonClick = useCallback(() => {
    if (isListening) {
      stopListening();
    } else {
      startListening();
    }
  }, [isListening]);

  const startListening = () => {
    setIsListening(true);
    // SpeechRecognition setup
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onresult = (event: { results: { [x: string]: { transcript: any; }[]; }; resultIndex: string | number; }) => {
      const transcript = event.results[event.resultIndex][0].transcript;
      console.log("Recognized Speech: ", transcript);
      sendToBot(transcript); // Send speech as text to bot
    };

    recognition.onend = () => {
      setIsListening(false); // Reset listening state
    };

    recognition.start();
  };

  const stopListening = () => {
    setIsListening(false);
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.stop();
    }
  };

  const sendToBot = (message: any) => {
    setMessage(message);
    setSendMessage(true);
  };
console.log("bot num",bot)
  return (
    <div className="minimizable-web-chat">
      {minimized && (
        <>
          {isVisible && notify?.length > 0 && (<>
            <div className='message-bubble'
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '95px',
                // backgroundColor: '#111827',
                backgroundColor: "#3c1053",
                color: 'white',
                flexDirection:'column',
                borderRadius: '12px',
                padding: '10px 14px',
                width: 'fit-content',
               
                display: 'flex',
                gap: '8px',
                alignItems: 'start',
                justifyContent: 'space-between',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                zIndex: 1000,
              }}
            >
 <i
                className="bi bi-x d-flex justify-content-center align-items-center"
                style={{
                  fontSize: '16px',
                
                  cursor: 'pointer',
                  flexShrink: 0,
                }}
                onClick={() => setIsVisible(false)}
              ></i>
              {/* Left side: chat icon + text */}
              <div
                style={{
                  display: 'flex',
                  flexDirection:'column',
                  alignItems:'left',
                  gap: '4px',
                  overflow: 'hidden', // ensures text doesn’t overflow
                }}
              >
                
                <p style={{  lineHeight: 1.3, margin: 0, overflowWrap: 'anywhere' }}>
                  {notify}
                </p>
              </div>

              {/* Close (X) icon */}
             
            </div>

          </>
          )}

          <button className="maximize d-flex justify-content-center align-items-center" onClick={handleMaximizeButtonClick} type="button">
            
            <img style={{ height: "100%" }} src={"https://itika-va.warwick.ac.uk/ui/warwickBotlogo_final.png"
 } alt="Company Logo" />
            {/* <i className={token ? 'bi-chat-square text-success' : 'bi-chat-square '} /> */}
            {newMessage && <i className="bi-brightness-high-fill text-danger red-dot" />}
          </button>
        </>

      )}
      {loaded && (
        <div
          className={classNames(
            side === 'left' ? 'chat-box left' : 'chat-box right',
            minimized ? 'hide' : '',
            isExpanded ? 'expanded' : 'collapse' // Apply expanded class when expanded
          )}
        >

          <header>
            <div className="chat-brand-logo">
              <img src={ "https://itika-va.warwick.ac.uk/ui/warwickBotlogo_final.png"
 } alt="Company Logo" />
              <div className="chat-brand-txt"><span>Itika</span></div>
            </div>

            <div className="filler" />


            <button className="minimize" onClick={handleMinimizeButtonClick} type="button">
              <i className="bi bi-dash d-flex justify-content-center align-items-center fs-4" /> 
              {/* bi-dash */}
            </button>

          </header>
          <WebChat
            className="react-web-chat"
            onFetchToken={handleFetchToken}
            store={store}
            styleOptions={styleOptions}
            styleSet={styleSet}
            token={token}
            sendMessage={sendMessage}
            setSendMessage={(value) => { setSendMessage(value) }}
            message={message}
          />
        </div>
      )}
    </div>
  );
}

export default memo(MinimizableWebChat);
